import React from 'react';

/**
 * Page title block: optional split row (title + lead | actions).
 * @param {React.ReactNode} title
 * @param {React.ReactNode} [lead]
 * @param {React.ReactNode} [actions] — right column (buttons, badges)
 */
function PageHead({ title, lead, actions, className = '' }) {
  const hasSplit = Boolean(actions);

  if (hasSplit) {
    return (
      <header className={`page-head${className ? ` ${className}` : ''}`}>
        <div className="page-head__row">
          <div className="page-head__text">
            <h1 className="page-title">{title}</h1>
            {lead != null && lead !== '' && <div className="page-lead">{lead}</div>}
          </div>
          {actions}
        </div>
      </header>
    );
  }

  return (
    <header className={`page-head${className ? ` ${className}` : ''}`}>
      <h1 className="page-title">{title}</h1>
      {lead != null && lead !== '' && <div className="page-lead">{lead}</div>}
    </header>
  );
}

export default PageHead;
